import React, { useState } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { IconButton } from "@mui/material";
import { Copyright, Visibility, VisibilityOff } from "@mui/icons-material";
import SnackbarComponent from "../Common/SnackbarComponent";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../Common/Loader";

export default function Login() {
  const navigate = useNavigate();
  const [username, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [snackbarMsg, setSnackbarMSg] = useState("");
  const [snackbarSevierty, setSnackbarSevierty] = useState("success");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}login`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ username, password }),
        }
      );

      if (response.ok) {
        const data = await response.json();
        const { token, username, role, name } = data;
        // Store the received JWT token in the session
        sessionStorage.setItem("token", token);
        sessionStorage.setItem("username", username);
        sessionStorage.setItem("role", role);
        sessionStorage.setItem("name", name);
        // setUserName("");
        // setPassword("");
        setMsg("");
        navigate(`/${sessionStorage.getItem("role").toLowerCase()}Dashboard`);
      } else {
        setMsg("Username or Password is Incorrect");
        setUserName("");
        setPassword("");
      }
    } catch (error) {
      setSnackbarMSg("Something went wrong!!", error);
      setSnackbarOpen(true);
      setSnackbarSevierty("error");
      setUserName("");
      setPassword("");
    }
    setIsLoading(false);
  };
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const closeSnackbar = () => {
    setSnackbarOpen(false);
  };
  const defaultTheme = createTheme();
  return (
    <div>
      <SnackbarComponent
        open={snackbarOpen}
        severity={snackbarSevierty}
        message={snackbarMsg}
        onClose={closeSnackbar}
      ></SnackbarComponent>
      {isLoading ? (
        <Loader />
      ) : !sessionStorage.getItem("role") ? (
        <div className="container-fluid my-5 d-flex align-items-center justify-content-center">
          <div className="card shadow-sm p-4">
            <div className="card-body">
              <ThemeProvider theme={defaultTheme}>
                <Container component="main" maxWidth="xs">
                  <CssBaseline />
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <Avatar sx={{ m: 1, bgcolor: "#fe8366" }}>
                      <LockOutlinedIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                      Sign in
                    </Typography>
                    <Box
                      component="form"
                      onSubmit={handleLogin}
                      noValidate
                      sx={{ mt: 1 }}
                    >
                      <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="name"
                        label="Username"
                        name="name"
                        autoComplete="name"
                        autoFocus
                        onChange={(e) => setUserName(e.target.value)}
                      />
                      <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Password"
                        type={showPassword ? "text" : "password"}
                        id="password"
                        autoComplete="current-password"
                        onChange={(e) => setPassword(e.target.value)}
                        InputProps={{
                          endAdornment: (
                            <IconButton onClick={togglePasswordVisibility}>
                              {showPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          ),
                        }}
                      />
                      <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 3, mb: 2 }}
                        disabled={
                          username.trim() === "" || password.trim() === ""
                        }
                      >
                        Sign In
                      </Button>
                    </Box>
                  </Box>
                  <p style={{fontSize:"11px"}}><Copyright className="fs-5"/> Credentials will be supplied by the
                  administrator, and in the event of a forgotten password,
                  please reach out to the administrator.</p>
                </Container>
              </ThemeProvider>
              {msg ? <span className="text-danger mx-4">{msg}</span> : <></>}
            </div>
          </div>
        </div>
      ) : (
        <div className="container my-5 py-5">
          <Container maxWidth="sm" sx={{ textAlign: "center", mt: 5 }}>
            <Typography variant="h4" gutterBottom>
              You Are Already Logged In
            </Typography>
            <Typography variant="body1" paragraph>
              You are currently logged in and cannot access this page.
            </Typography>
            <Button
              component={Link}
              to={`/${sessionStorage.getItem("role").toLowerCase()}Dashboard`}
              variant="contained"
              color="primary"
            >
              Go to Dashboard
            </Button>
          </Container>
        </div>
      )}
    </div>
  );
}
